/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { AgFns, EntityFinderDialog, EntityFinderParams, ISortModel } from '@core';

import { ActiveStatusEnum, ProductTypeConfig } from '@models';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { UtilFns } from '@utils';
import { ColDef } from '@ag-grid-community/core';
import { AccountDbQueryService } from '../services/account-db-query.service';

export interface ChangeProductTypeConfigParams extends EntityFinderParams {
  pricedProductTypeId: string;
  currentConfigId: string;
}

@Component({
  selector: 'prox-change-product-type-config-dialog',
  template: EntityFinderDialog.HTML,
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class ChangeProductTypeConfigDialog extends EntityFinderDialog<ProductTypeConfig, ChangeProductTypeConfigParams> {
  params!: ChangeProductTypeConfigParams;

  constructor(
    ref: DynamicDialogRef,
    override config: DynamicDialogConfig<ChangeProductTypeConfigParams>,
    public dbQueryService: AccountDbQueryService,
  ) {
    super(ref, config);
    UtilFns.assertNonNull(config.data);
    this.params = config.data;
  }

  override async initialize() {
    return {
      header: this.params.header || 'Change Configuration',
      width: 'calc(45vw)',
    };
  }

  override async initDatasource() {
    // Only Active configs are valid alternatives — Inactive configs are supplier-side losers
    // in the consolidation model and must not be selectable.
    const query = this.dbQueryService
      .createQuery(ProductTypeConfig)
      .where({ pricedProductTypeId: this.params.pricedProductTypeId, activeStatusId: ActiveStatusEnum.Active })
      .expand('pricedProductType.productType.supplier, pricedProductType.productType.manufacturer');

    const configs = await query.execute();

    return configs.filter((c) => c.id !== this.params.currentConfigId);
  }

  override getColDefsAndSortModel() {
    const colDefs = [
      { headerName: 'Supplier', field: 'pricedProductType.productType.supplier.name', ...AgFns.flexWidth(160) },
      { headerName: 'Manufacturer', field: 'pricedProductType.productType.manufacturer.name', ...AgFns.flexWidth(160) },
      { headerName: 'Config / Catalog', field: 'name', ...AgFns.fixWidth(200) },
      { headerName: 'Name', field: 'pricedProductType.productType.name', ...AgFns.flexWidth(120) },
      // { headerName: 'Description', field: 'pricedProductType.productType.description',  },
      { headerName: 'Base Price', field: 'pricedProductType.basePrice', ...AgFns.fixWidth(120) },
    ] as ColDef[];
    const sortModel = [{ colId: 'name', sort: 'asc' }] as ISortModel;
    return [colDefs, sortModel] as const;
  }
}
